import { render, staticRenderFns } from "./AddResourcesa.vue?vue&type=template&id=87cf2bc0&"
import script from "./AddResourcesa.vue?vue&type=script&lang=js&"
export * from "./AddResourcesa.vue?vue&type=script&lang=js&"
import style0 from "./AddResourcesa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports